var ReactTooltip = require("react-tooltip");

import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");

var DataRouting = require("lib/routing/DataRouting");

var WritingActions = require("lib/actions/WritingActions");
var ReadingActions = require("lib/actions/ReadingActions");

var WritingSelectors = require("lib/selectors/WritingSelectors");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var WidgetConfig = require('lib/widgets/WidgetsConfig')

var QuizDisplay = require("components/writing/quizzes/QuizDisplay");
var AnswerDisplay = require("components/writing/answers/AnswerDisplay");
var PaginationControls = require("components/utility/PaginationControls");
var Spinner = require("components/utility/Spinner");
var NoActivityBlock = require("components/data/subjects/shared/NoActivityBlock");
var DataTable = require("components/data/subjects/shared/DataTable");
var EmptyState = require("components/data/EmptyState");
var ScoreDisplay = require("components/writing/evaluations/ScoreDisplay");
var Glyphicon = require("components/utility/icons/Glyphicon");

import moment from 'moment';

function propsToConditions(props) {
    var conditions = _.pick(props,
        "startDate", "endDate", "userIDs", "order", "status"
    );
  
    conditions.perPage = props.perPage || DataRouting.PER_PAGE;
    conditions.withTotal = true;
  
    if (conditions.startDate && conditions.endDate) {
        // reverse the time zone offset pull all quizzes based
        // on the user's time zone
        var currentUser = CurrentUser.get()
        if (currentUser.time_zone_offset) {
            var offset = -currentUser.time_zone_offset / (60 * 60);
        } else {
            var offset = 7 // default to Pacific time
        }

        conditions.startDate = moment(conditions.startDate).startOf('day').utcOffset(offset).format("YYYY-MM-DD")
        conditions.endDate = moment(conditions.endDate).endOf('day').utcOffset(offset).format("YYYY-MM-DD")
    }
  
    return conditions;
}

function sortItems(essays) {
    return _.sortBy(essays, (x) => (new Date(x.completed_at)).valueOf()).reverse();
}
  
@connect(
    (state, props) => ({
        loading: WritingSelectors.isLoadingAnswers({ state, key: 'index', userIDs: props.userIDs }),
        essays: sortItems(WritingSelectors.essayAnswers({ state, conditions: propsToConditions(props) }))
    }),
    (dispatch, props) => ({
        populateData: () => {
            var conditions = _.pick(props, "startDate", "endDate", "order", "status")
            var actionFunction = WritingActions.fetchEssayAnswers      
            var embeds = ["answer.evaluation", "answer.question", "evaluation.score_details"]      
      
            var options = { embeds, cache: true }
            return new Promise(function (resolve, reject) {
              $wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, null);
      
            }).catch(() => console.log("Essays failed to load"))
        },
        selectEvaluation: (evaluationID) => {
            return dispatch((dispatch, getState) => {
              return WritingSelectors.evaluation({ state: getState(), id: evaluationID })
            })
        },
        selectStudent: (studentID) => {
            return dispatch((dispatch, getState) => {
              return RosterSelectors.student({ state: getState(), id: studentID })
            })
        },
    })
)
@providePopulateData()
class DataEssayTables extends React.Component {
    constructor(props) {
        super();
        autobind(this);

        this.state = {
            essayChunks: _.chunk(props.essays, DataRouting.PER_PAGE),
            currentEssayPage: 1,
            totalCount: _.size(props.essays),
            showAdditionalAnswers: false,
            currentAnswerPage: 1
        }

  }

  singleQuiz() {
    if (!this.props.quizID) { return null }    
    return _.findWhere(this.props.quizzes, { id: this.props.quizID })
  }
  
  onEssayPageChange(page) {
    this.setState({ currentEssayPage: page });
  }

  changeLocationState(essayID, controlMode) {    
    if (!_.isEmpty(this.props.prevLocationState)) {
      var newLocationState = { ...this.props.prevLocationState }
    } else if (essayID && essayID != null) {
      var newLocationState = { ...this.props.locationState }
      newLocationState.essayID = essayID
    } else {
      var newLocationState = _.omit({ ...this.props.locationState }, 'essayID')
    }

    this.props.updateRoute(newLocationState)
  }

    // link that sends user to essay view with edit tab open
    renderGradeEssayLink(essay) {
        return (
          <a onClick={() => this.changeLocationState(essay.id, EDIT_CONTROLS)} className='gradeEssayLink'>
            {`Grade Essay`}
          </a>
        )
      }

  formatDate(date) {
    return $wr.formatDate(date, "MM/DD/YY")
  }

  // link to view quiz answers
  buildViewLink(essayID) {
    return (
      <span className="itemLink">
        <a className='hideOnPrint' onClick={() => this.changeLocationState(essayID)}>
          <Glyphicon icon="new-window" />
        </a>
      </span>
    )
  }

  generateEssayRows(essays) {
    return _.map(essays, essay => {
        var { completed_at, user_id, evaluation, question_text } = essay

        // evaluation for essay
        var evaluation = this.props.selectEvaluation(evaluation)
        // student information
        var student = this.props.selectStudent(user_id)
        
        if (evaluation && (evaluation.score_details.admin_score || evaluation.score > 0)) {
            var evalValue = <ScoreDisplay evaluationID={evaluation.id} changeLocationState={this.changeLocationState} mode={ScoreDisplay.SCORE_ONLY_MODE} isEssay/>
        } else {
            var evalValue = this.renderGradeEssayLink(essay)
        }

      return [
        {
            // date column
            value: this.formatDate(completed_at),
            classes: ['no-wrap', 'dateColumn']
        },
        {
            // student name column
            value: student.display_name,
            classes: ['studentNameColumn'],
        },
        {
            value: question_text,
            classes: ['essayColumn'],
        },
        {
            // displays quiz evaluation score
            value: evalValue,
            classes: ['bold', 'essayScoreColumn']
        },
        {
            // view quiz answers
            value: this.buildViewLink(essay.id),
            classes: ['no-wrap', 'viewColumn'],
        },
      ]
    })
  }

  onEssayPageChange(page) {
    this.setState({ currentEssayPage: page });
  }

  loadPagination() {
    if (this.state.totalCount && !this.props.quizID) {
      return (
        <PaginationControls page={this.state.currentEssayPage}
          perPage={DataRouting.PER_PAGE}
          totalCount={this.state.totalCount}
          onPageChange={this.onEssayPageChange} />
      )
    }
  }

  // chunks and returns answer displays and total count
  renderAnswerDisplays() {
    var enabled = { ...this.props.enabled };
    var view = AnswerDisplay.ANSWERS_VIEW;
    var answers = _.map(this.additionalAnswerIDs(), (aid, i) => {
      if (i != _.size(this.additionalAnswerIDs()) - 1) {
        var divider = <hr />
      }

      return (
        <span>
          <AnswerDisplay answerID={aid} key={aid}
            enabled={enabled} view={view} />
          {divider}
        </span>
      )
    })

    return { 'totalCount': _.size(answers), 'answers': _.chunk(answers, DataRouting.PER_PAGE)[this.state.currentAnswerPage - 1] }
  }

  renderPracticeQuestions() {
    if (!_.isEmpty(this.additionalAnswerIDs())) {
      var { totalCount, answers } = this.renderAnswerDisplays()
      var expandedClass = 'collapsed'
      var header = `${_.size(this.additionalAnswerIDs())} Practice ${$wr.pluralize('Question', _.size(this.additionalAnswerIDs()), 'Questions')} For This Text`
      var icon = 'menu-down'

      if (this.state.showAdditionalAnswers) {
        expandedClass = 'expanded'
        header = `Hide Practice ${$wr.pluralize('Question', _.size(this.additionalAnswerIDs()), 'Questions')}`
        icon = 'menu-up'
      }

      return (
        <div className={`additonalAnswersContainer ${expandedClass}`}>
          <div className="headerSection" onClick={this.toggleShowAdditionalAnswers}>
            {header}
            <div className="menuOption"><Glyphicon icon={icon}/></div>
          </div>
          <div className="answersContainer">
            <PaginationControls page={this.state.currentAnswerPage}
              perPage={DataRouting.PER_PAGE}
              totalCount={totalCount}
              onPageChange={this.onAnswerPageChange} />
            {answers}
          </div>
        </div>
      )
    }
  }

  renderSingleEssayDisplay() {
    return (
      <div className="singleQuizView">
        <AnswerDisplay answerID={ this.props.essayID } key={ this.props.essayID } enabled={{ ...this.props.enabled }}  />
      </div>
    )
  }

  renderEssayDisplay() {
    if (this.props.loading) {
      return <Spinner />
    } 

    var essays = this.props.showFullData ? this.state.essayChunks[this.state.currentEssayPage - 1] : _.first(this.props.essays, 1);
    if (essays) {
      if (this.props.fakePerPage) {
        essays = _.first(essays, this.props.fakePerPage)
      }
      // if essayID param, show single essay with all answers
      // else, show table of essayzes
      if (this.props.essayID) {
        return this.renderSingleEssayDisplay()
      } else {
        return (
          <DataTable
            subjectType={ESSAYS}
            columnHeaders={ESSAY_TABLE_HEADERS}
            rows={this.generateEssayRows(essays)}
            printable={false}
          />
        )
      }
    } else {
      if (this.props.sketchEmptyState) {
        return <NoActivityBlock userIDs={this.props.userIDs} contentType="Essays" />
      } else {
        return <EmptyState type={ESSAYS} />
      }
    }
  }

  renderPrintableEssayDisplay() {
    var { essays, loading } = this.props
    if (!this.props.quizID && essays && !loading) {
      var essays = _.flatten(this.state.essayChunks)
      return (
        <DataTable
          subjectType={ESSAYS}
          columnHeaders={ESSAY_TABLE_HEADERS}
          rows={this.generateEssayRows(essays)}
          printable={true}
        />
      )
    }
  }

  render() {
    return (
      <div className="dataEssayTables">
        {this.loadPagination()}
        {this.renderEssayDisplay()}
        {this.renderPrintableEssayDisplay()}
        {this.loadPagination()}
      </div>
    )
  }
}

var ESSAYS = "essays";
var ESSAY_TABLE_HEADERS = ['Date', 'Student', 'Prompt', 'Score', '']
var EDIT_CONTROLS = "Edit";

DataEssayTables.defaultProps = {
  enabled: {}
}

DataEssayTables.WrappedComponent.propTypes = PageStrictPropTypes({
  // Data from above
  userIDs: PropTypes.array,
  startDate: PropTypes.string,
  page: PropTypes.number,
  perPage: PropTypes.number,
  fakePerPage: PropTypes.number,
  order: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  status: PropTypes.string,
  showFullData: PropTypes.bool,
  sketchEmptyState: PropTypes.bool,
  studentList: PropTypes.string,
  essayID: PropTypes.number,
  locationState: PropTypes.object,
  prevLocationState: PropTypes.object,
  updateRoute: PropTypes.func,
  onPageChange: PropTypes.func,

  // Reference QuizDisplay 'enabled'
  enabled: PropTypes.object,

  // Data from @connect
  loading: PropTypes.bool,
  essays: PropTypes.array,

  // Handlers from @connect
  populateData: PropTypes.func,
  selectEvaluation: PropTypes.func,
  selectStudent: PropTypes.func,
})

module.exports = DataEssayTables;


// WEBPACK FOOTER //
// ./modules/components/data/subjects/DataEssayTables.js